export default __webpack_public_path__ + "static/media/payment.e6c41cc8.svg";